
// Metadata for the armpit health basics article
export const armpitHealthBasicsMetadata = {
  id: "armpit-health-basics",
  slug: "armpit-health-basics",
  title: "Essential Guide to Armpit Health: Hygiene Practices and Prevention Tips",
  excerpt: "Learn the essential aspects of maintaining proper armpit health, from hygiene practices to identifying common issues and prevention strategies.",
  publishedAt: "June 15, 2023",
  readTime: "8 min read",
  category: "Health",
  image: "/lovable-uploads/2abc262b-2602-434c-9ab6-cbf39724a4b0.png",
  metaDescription: "Comprehensive guide to armpit health covering hygiene best practices, common issues, prevention strategies, and when to seek medical attention for underarm problems.",
  keywords: ["armpit health", "underarm hygiene", "prevent armpit odor", "armpit care", "armpit skin health", "natural deodorant"],
};
